import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import * as S from './FloatingButtons.styles';
import { PhoneIcon } from '@/components/UI/Icons/Icons';
import { PhonesBottomSheet } from '@/components/PhonesBottomSheet/PhonesBottomSheet';
import { useOpenContacts } from '@/hooks/useOpenContacts';
import { useAdDetails } from '@/hooks/useAdDetails';
import { useFloatingButtonsVisibility } from '@/hooks/useFloatingButtonsVisibility';
import { useServerDataContext } from '@/contexts';

export const CallButton = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const { isCallsAvailable } = useFloatingButtonsVisibility();
  const { isContactsOpen, toggleContacts, getPhoneNumbers, phoneNumbers } =
    useOpenContacts();
  const theme = useTheme();

  if (!adData?.id || !isCallsAvailable) return null;

  return (
    <>
      <S.FloatingButton
        data-testid="floating-call-button"
        appearance="green"
        borderRadius={14}
        isFullWidth
        onClick={() =>
          getPhoneNumbers({
            adId: adData.id,
            isFloatingButtonClicked: true,
          })
        }
        className="fixed-btn fixed-btn--phone js-bottom-phone"
      >
        <S.ButtonIconBox>
          <PhoneIcon />
        </S.ButtonIconBox>{' '}
        {t('common.call')}
      </S.FloatingButton>
      <PhonesBottomSheet
        isOpen={isContactsOpen}
        close={toggleContacts}
        phones={phoneNumbers}
        color={theme.palette.system.green}
      />
    </>
  );
};
